import React from "react";
import AppView from "../../components/Layout/AppView";

const AdminPage = () => {
  return <AppView>Admin Page</AppView>;
};

export default AdminPage;
